import axios from 'axios';
import {PROVIDERS_EXPERIENCES_URL} from "../../../../config";

export function fetchMeetingPointAutocomplete(searchInput, sessionToken, experienceId) {
    return axios.post(
        PROVIDERS_EXPERIENCES_URL + '/meeting-point/autocomplete',
        {
            "search_input": searchInput,
            "session_token": sessionToken,
            'id': experienceId
        }
    );
}

export function getMeetingPointPlaceFromAutocomplete(placeId, sessionToken, experienceId) {
    return axios.get(PROVIDERS_EXPERIENCES_URL + `/meeting-point/place-autocomplete/${placeId}?session_token=${sessionToken}&id=${experienceId}`);
}

export function fetchMeetingPointPlaceFromCoordinates(latitude, longitude, experienceId) {
    return axios.post(
        PROVIDERS_EXPERIENCES_URL + '/meeting-point/place-coordinates',
        {
            "latitude": latitude,
            "longitude": longitude,
            'id': experienceId
        }
    );
}